<template>
  <div :class="['navbar space-between align-center', navbarClass]">
    <div :class="[isNoSidebar ? 'no-sidebar' : '', 'flex align-center']">
      <div
        v-if="!isNoSidebar"
        id="burger"
        :class="{ active: humburgerMenu }"
        @click.prevent="toggleNav"
      >
        <slot>
          <button type="button" class="burger-button" title="Menu">
            <span class="burger-bar burger-bar--1"></span>
            <span class="burger-bar burger-bar--2"></span>
            <span class="burger-bar burger-bar--3"></span>
          </button>
        </slot>
      </div>
      <div class="logo cursor" v-if="isNoSidebar">
        <router-link :to="redirectTo">
          <img
            :src="userInfo && userInfo.bussinessLogoUrl"
            alt="logo"
            class="responsive"
          />
        </router-link>
      </div>
    </div>
    <div>
      <AlertBanner />
      <UpdateNotificationBanner />
    </div>
    <div class="profile">
      <div class="user cursor" @click="handleMenu" v-if="isLoggedIn">
        <button>
          <img class="user-img" :src="profile" alt="avatar" />
          <div class="user-status-indicator" v-if="isOnline"></div>
        </button>
        <div>
          <p class="capitalize">
            {{ userInfo && userInfo.full_name }}
          </p>
          <span class="capitalize">{{ this.userInfo.userRole[0].name }}</span>
        </div>
        <span class="mdi mdi-chevron-down user-caret"></span>
      </div>
      <div class="dropdown" v-if="isLoggedIn">
        <transition name="fade">
          <div class="menu" v-if="showMenu">
            <div
              class="menu-item"
              v-for="item in items"
              :key="item"
              @click="handleItems(item)"
            >
              {{ item }}
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";
import AlertBanner from "@/components/AlertBanner";
import UpdateNotificationBanner from "./UpdateNotificationBanner.vue";

export default {
  data: () => ({
    showMenu: false,
    items: ["Profile", "Sign out"],
    humburgerMenu: false,
    bussinessLogo: "",
    isOnline: navigator.onLine
  }),
  components: {
    AlertBanner,
    UpdateNotificationBanner
  },
  methods: {
    ...mapActions({
      toggleNav: "toggleNav",
      fetchBranch: "expenses/fetchBranch",
      validateSession: "auth/validateSession"
    }),
    ...mapActions("auth", ["checkUpdateNotification"]),
    ...mapActions("bussiness", ["settingsList"]),
    async handleItems(item) {
      if (item == "Sign out") {
        const payload = {
          userId: this.userInfo.id,
          sessionId: this.userInfo.currentUserSession.sessionId
        };
        await this.validateSession({ vm: this, payload });
        this.$store.dispatch("auth/logout", { vm: this }).then(() => {
          this.$router.push("/");
        });
      } else if (item == "Profile") {
        this.$router.push("/profile");
      }
      this.handleMenu();
    },
    handleMenu() {
      this.showMenu = !this.showMenu;
    },
    close(e) {
      if (!this.$el.contains(e.target)) {
        this.showMenu = false;
      }
    },
    updateOnlineStatus() {
      this.isOnline = navigator.onLine;
    }
  },
  computed: {
    ...mapState({
      isNavOpen: state => state.isNavOpen
    }),
    ...mapGetters({
      isLoggedIn: "auth/isLoggedIn",
      userInfo: "auth/userInfo",
      role: "auth/role",
      settings: "bussiness/settings",
      fetchUserBranch: "expenses/fetchUserBranch",
      validateSessionStatus: "auth/validateSessionStatus"
    }),
    navbarClass() {
      if (this.isNoSidebar) return "navbar--full";
      return this.isNavOpen ? "navbar--docked" : "navbar--docked-sm";
    },
    isUserAuthenticated() {
      return this.isLoggedIn;
    },
    userRole() {
      const role = this.role || [];
      if (role && role.length > 1) {
        return "super-admin";
      } else {
        return role[0] && role[0].name;
      }
    },
    redirectTo() {
      const role = this.role || [];
      const userRole = role.map(item => item.name);
      if (userRole.includes("receptionist")) {
        return "/registration/register";
      } else if (userRole.includes("technician")) {
        return "/registration/register";
      } else {
        return "/";
      }
    },
    profile() {
      return (
        (this.userInfo && this.userInfo.profile) ||
        require("../assets/upload.png")
      );
    },
    isNoSidebar() {
      return this.$route.meta.layout == "nosidebar-layout";
    }
  },
  async mounted() {
    document.addEventListener("click", this.close);
    window.addEventListener("online", this.updateOnlineStatus);
    window.addEventListener("offline", this.updateOnlineStatus);

    // Check for update notifications if not already checked
    if (this.isLoggedIn && !localStorage.getItem("bannerUpdateInfo")) {
      console.log("Checking for update notifications from Navbar...");
      this.checkUpdateNotification();
    }
  },
  beforeDestroy() {
    document.removeEventListener("click", this.close);
    window.removeEventListener("online", this.updateOnlineStatus);
    window.removeEventListener("offline", this.updateOnlineStatus);
  }
};
</script>
<style>
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  z-index: 1500;
  align-items: center;
  background-color: var(--surface);
  border-bottom: 1px solid var(--line);
  box-shadow: var(--shadow-sm);
  padding: 12px 0;
  transition: left var(--dur) var(--ease), width var(--dur) var(--ease);
}

/* Dock the topbar beside the full-height rail (matches the design) */
.navbar--docked {
  left: 236px;
  width: calc(100% - 236px);
}
.navbar--docked-sm {
  left: 72px;
  width: calc(100% - 72px);
}
@media (max-width: 768px) {
  .navbar--docked,
  .navbar--docked-sm {
    left: 0;
    width: 100%;
  }
}

.navbar .no-sidebar {
  margin-left: 1.9rem;
}

.navbar .vs__dropdown-toggle {
  position: absolute;
  cursor: pointer !important;
  top: -38px;
  right: 20px;
  border: none;
  opacity: 0;
}

.navbar .vs__dropdown-menu {
  left: -60px !important;
  max-width: 50px !important;
}

.cursor {
  cursor: pointer;
}

.logo {
  margin-top: 6px;
}

.user-img {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  object-fit: cover;
  box-shadow: 0 0 0 1px var(--line);
}

#burger {
  margin-right: 14px;
  margin-left: 12px;
}

button {
  cursor: pointer;
}

/* remove blue outline */
button:focus {
  outline: 0;
}

.burger-button {
  position: relative;
  height: 38px;
  width: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
  border: 0;
  border-radius: var(--radius-sm);
  background-color: transparent;
  pointer-events: all;
  transition: background-color var(--dur) var(--ease);
}
.burger-button:hover {
  background-color: var(--surface-2);
}

.burger-bar {
  background-color: var(--muted);
  border-radius: 30px 0px 0px 0px;
  position: absolute;
  top: 50%;
  right: 6px;
  left: 6px;
  height: 2px;
  width: auto;
  margin-top: -1px;
  transition: transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1),
    opacity 0.3s cubic-bezier(0.165, 0.84, 0.44, 1),
    background-color 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.burger-bar--1 {
  -webkit-transform: translateY(-6px);
  transform: translateY(-6px);
}

.burger-bar--2 {
  transform-origin: 100% 50%;
  transform: scaleX(0.8);
}

.burger-button:hover .burger-bar--2 {
  transform: scaleX(1);
}

.no-touchevents .burger-bar--2:hover {
  transform: scaleX(1);
}

.burger-bar--3 {
  transform: translateY(6px);
}

.burger-button:hover .burger-bar {
  background-color: var(--ink-900);
}

.profile {
  position: relative;
  margin-right: 24px;
  display: flex;
  align-items: center;
}

.profile .user {
  display: flex;
  position: relative;
  align-items: center;
  padding: 4px 10px 4px 4px;
  border-radius: var(--radius-md);
  transition: background-color var(--dur) var(--ease);
}

.profile .user:hover {
  background-color: var(--surface-2);
}

.profile .user img {
  margin-right: 12px;
}

.profile .user button {
  background: none;
  border: none;
  position: relative;
}

.user-status-indicator {
  position: absolute;
  bottom: 2px;
  right: 12px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: var(--success);
  /* Green for online */
  border: 2px solid var(--surface);
}

.profile .user p {
  margin: 0;
  padding: 0;
  font-weight: 600;
  font-size: var(--fs-body);
  line-height: 1.25;
  color: var(--ink-900);
}

.profile .user span {
  font-style: normal;
  font-weight: normal;
  font-size: 0.75rem;
  line-height: 16px;
  color: var(--muted);
}

.dropdown {
  margin-left: 8px;
}

.menu {
  background-color: var(--surface);
  background-clip: padding-box;
  border: 1px solid var(--line);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-md);
  color: var(--text);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  list-style: none;
  position: absolute;
  top: 100%;
  right: 0;
  left: auto;
  text-align: left;
  min-width: 190px;
  padding: 6px;
  margin-top: 10px;
  z-index: 1600;
}

.menu-item {
  font-weight: 500;
  font-size: var(--fs-sm);
  line-height: 1.4;
  text-transform: capitalize;
  color: var(--text);
  padding: 9px 12px;
  border-radius: var(--radius-sm);
  transition: color var(--dur) var(--ease),
    background-color var(--dur) var(--ease);
}

.menu-item:last-child {
  border-bottom: none;
}

.menu-item:hover {
  background-color: var(--surface-2);
  cursor: pointer;
}

.dropdown span {
  color: var(--muted);
  font-weight: bold;
  font-size: 1.25rem;
}

/* Sign out affordance */
.menu-item:last-child {
  color: var(--danger);
}

.user-caret {
  color: var(--muted-soft);
  font-size: 1.125rem;
  margin-left: 4px;
}
</style>
